import React from 'react';
import StepCaptchaOverlay from './StepCaptchaOverlay';
import StepCaptchaScreencast from './StepCaptchaScreencast';

/**
 * Flag-routed captcha viewer.
 *
 * REACT_APP_USE_SCREENCAST_VIEWER=true → CDP-screencast canvas.
 * Anything else → legacy noVNC cropped iframe.
 *
 * The flag is read at module-eval time so a build flips between the
 * two implementations cleanly. There's intentionally no runtime
 * toggle: a flag flip mid-takeover would mount the wrong component
 * over an already-active stream.
 *
 * The two underlying components share an identical prop contract
 * (sessionId + onError(reason)), so each step file does a single
 * import + JSX-tag swap to opt in.
 */
const USE_SCREENCAST = process.env.REACT_APP_USE_SCREENCAST_VIEWER === 'true';

export default function StepCaptchaViewer(props) {
  if (USE_SCREENCAST) return <StepCaptchaScreencast {...props} />;
  return <StepCaptchaOverlay {...props} />;
}
